export default __webpack_public_path__ + "static/media/jmb.fd23d2d3.png";